import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import AssignmentsComp from './AssignmentsComp'

function Assignments() {
  return (
    <div className='mainContainer'>
      <LeftmenuIn />
      <div className='theMainContainer'>
        <DashnavIn />
        <AssignmentsComp />
      </div>
    </div>
  )
}

export default Assignments
